import React, { FC } from 'react'
import styled, { keyframes } from 'styled-components'
interface LoadingIconProps {
  size?: number
  prefix?: string
  color?: string
  noMargin?: boolean
}
export const LoadingIcon: FC<LoadingIconProps> = props => {
  return (
    <StyleLoading {...props}>
      <div />
      <div />
      <div />
    </StyleLoading>
  )
}

// loading icoin
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`
const StyleLoading = styled.div<LoadingIconProps>`
  display: inline-block;
  position: relative;
  width: ${props => props.size ?? 24}${props => props.prefix ?? 'px'};
  height: ${props => props.size ?? 24}${props => props.prefix ?? 'px'};
  > div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 50%;
    height: 50%;
    margin:  ${props => props.noMargin ? '0' : '30%'};
    border: 0.3em solid #fff;
    border-radius: 50%;
    animation: ${rotate} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${props => props.color ?? '#2196f3'} transparent transparent transparent;
    &:nth-child(1) {
      animation-delay: -0.45s;
    }
    &:nth-child(2) {
      animation-delay: -0.3s;
    }
    &:nth-child(3) {
      animation-delay: -0.15s;
    }
  }
`
